import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import SecurityScorecardMappingForm from './SecurityScorecardMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function ScorecardCredentialsForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "SecurityScorecard Endpoint",
        required: true,
        rules:[urlRegexValidator],
    },{
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={SecurityScorecardMappingForm}
            initialValue={{ apiEndpoint: 'https://api.securityscorecard.io' }}
        />
    )
}

export default forwardRef(ScorecardCredentialsForm);